<div class="modal-header">
  <h4 class="modal-title"> {{'cadExportPopup.title' | translate}} </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner overflow-scrolling-touch">
    <p [innerHTML]="'cadExportPopup.header.description' | translate" ></p>
    <input type="text"
      spellcheck="false"
      class="form-control form-control-sm flex-grow-0 flex-shrink-0 mb-2"
      [placeholder]="'global.label.filter' | translate"
      (input)="filterCadFormat($event)">
    <table class="table table-striped table-hover table-sm fixed-layout" fixedHeader [virtual]="true">
      <thead>
        <tr>
          <th scope="col" #headerCadName>{{'cadExportPopup.datagrid.header.cad_name' | translate}}</th>
          <th scope="col" #headerCadVersion>{{'cadExportPopup.datagrid.header.cad_version' | translate}}</th>
        </tr>
      </thead>
    </table>
    <virtual-scroller maxHeightOffset="400" #scroll class="minh-200 overflow-xh ms-overflow-x" [items]="filteredCadFormats" [enableUnequalChildrenSizes]="true">
      <table class="table table-striped table-hover table-sm fixed-layout">
        <tbody class="new-stacking-context" #container>
          <tr class="middle" *ngFor="let cadFormat of scroll.viewPortItems" (click)="selectFormat(cadFormat)" [class.active]="cadFormat === selectedFormat">
            <td [attr.width.px]="headerCadName.clientWidth">{{cadFormat.name}}</td>
            <td [attr.width.px]="headerCadVersion.clientWidth">{{cadFormat.version}}</td>
          </tr>
        </tbody>
      </table>
    </virtual-scroller>
    <p class="mt-3" *ngIf="canExportWithLabeling">
      <b [innerHTML]="'cadExportPopup.label.export_labeling_info' | translate" ></b>
    </p>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="close()">{{'global.label.close' | translate}}</button>
  <button class="btn btn-primary btn-forward" (click)="export()" [disabled]="!selectedFormat" *ngIf="!canExportWithLabeling">
    {{'global.label.export' | translate}}
  </button>

  <!-- export buttons when labeling export is available -->
  <button class="btn btn-primary btn-forward" (click)="exportWithLabeling()" [disabled]="!selectedFormat" *ngIf="canExportWithLabeling">
    {{'cadExportPopup.label.export_with_labeling' | translate}}
  </button>
  <button class="btn btn-primary btn-forward" (click)="export()" [disabled]="!selectedFormat" *ngIf="canExportWithLabeling">
    {{'cadExportPopup.label.export_without_labeling' | translate}}
  </button>
</div>
